import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InvoiceLinesBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = new Date(this.insertDt);
        this.updateDt = new Date(this.updateDt);
        if (CommonFunctions.hasValue(this.sageDt)) {
            this.sageDt = new Date(this.sageDt);
        }
        if (CommonFunctions.hasValue(this.sageCostDt)) {
            this.sageCostDt = new Date(this.sageCostDt);
        }
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setParentId(id: any) {
        this.invoiceId = id;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
        this.sageCostDt = DateFunctions.getDateTimeWithUTCOffset(this.sageCostDt);

        }
    invoiceLineId: any;
    invoiceId: any;
    inventoryBillingCodeId: any;
    changeCodeId: any;
    sortOrder: number;
    quantity: number;
    cost: number;
    markup: number;
    price: number;
    isTaxable: boolean;
    isPrintable: boolean;
    isPart: boolean;
    invoiceLineDesc: string;
    qbid: string;
    qbEditSequenceId: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    personId: any;
    hourlyRate: number;
    overheadRate: number;
    overheadPercent: number;
    amount: number;
    inventoryLocationId: any;
    markupCost: number;
    fullDescription: string;
    tax: number;
    sageDt: Date;
    dispatchId: any;
    sageCostDt: Date;
    inventoryFromCode: string;
    excessInventoryLocationToId: any;
    originalQuantity: number;
    splitQuantity: number;
    origin : string;
    corr1IsBillable: boolean;
    corr2IsBillable: boolean;
    avalaraTaxCalculated: number;
    avalaraTaxTypeId: string;
    serialNumber: string;
}
